

import React, { useEffect, useState } from "react";
import { FaHeart, FaChevronLeft, FaChevronRight, FaShareAlt, FaChevronUp, FaChevronDown } from "react-icons/fa";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Header from '../HomePage/Header';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import HelpTrigger from '../HomePage/HelpTrigger';
import "./ProductDetails.css";

const ProductDetails = () => {
  const { id } = useParams(); 
  const [product, setProduct] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState('all');
  const [similarProducts, setSimilarProducts] = useState([]);
    const [detailsVisible, setDetailsVisible] = useState({
    customize: false,
    shipping: false,
    returns: false
  }); 

    const navigate = useNavigate();
 const [selectedMetalQuality, setSelectedMetalQuality] = useState('18Kt'); 
const [similarProductImageIndexes, setSimilarProductImageIndexes] = useState({});


useEffect(() => {
  setActiveImageIndex(0); // Reset to first image when color changes
}, [selectedColor]);


  // useEffect(() => {
  //   const fetchProductDetails = async () => {
  //     try {
  //       const productResponse = await axios.get(`https://spinelleapi.emedha.in/user/auth/api/products/${id}`);
  //       const imagesResponse = await axios.get('https://spinelleapi.emedha.in/user/auth/api/product_images');
        
  //       setProduct(productResponse.data);
  //       setProductImages(imagesResponse.data.filter(image => image.product_id === parseInt(id)));
  //     } catch (error) {
  //       console.error("Error fetching product details:", error);
  //     }
  //   };

  //   fetchProductDetails();
  // }, [id]);

useEffect(() => {
  const fetchProductDetails = async () => {
    try {
      // Fetch the details of the current product
      const productResponse = await axios.get(`https://spinelleapi.emedha.in/user/auth/api/products/${id}`);
      const imagesResponse = await axios.get('https://spinelleapi.emedha.in/user/auth/api/product_images');
      
      setProduct(productResponse.data);
      setProductImages(imagesResponse.data.filter(image => image.product_id === parseInt(id)));

      // Fetch similar products based on category and metal colors
      const category = productResponse.data.category || '';
      const metalColors = productResponse.data.metal_colors || [];

      const similarResponse = await axios.get('https://spinelleapi.emedha.in/user/auth/api/products', {
        params: {
          category,
          metal_colors: metalColors.join(','),
        }
      });

      // Filter out the current product from the similar products list
      const filteredSimilarProducts = similarResponse.data.filter(product => product.id !== parseInt(id));
      
      // Fetch images for each similar product
      const similarProductsWithImages = await Promise.all(filteredSimilarProducts.map(async (similarProduct) => {
        const similarProductImages = imagesResponse.data.filter(image => image.product_id === similarProduct.id);
        return { ...similarProduct, images: similarProductImages };
      }));

      setSimilarProducts(similarProductsWithImages);
      
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  fetchProductDetails();
}, [id]);


  
  const handlePrevImage = () => {
    setActiveImageIndex((prevIndex) => (prevIndex === 0 ? productImages.length - 1 : prevIndex - 1));
    setSelectedColor('all')
  };

  const handleNextImage = () => {
    setActiveImageIndex((prevIndex) => (prevIndex === productImages.length - 1 ? 0 : prevIndex + 1));
     setSelectedColor('all')
  };

const handlePrevImageSimilarProduct = (productId) => {
  setSimilarProductImageIndexes((prevState) => {
    const currentIndex = prevState[productId] || 0;
    const productImages = similarProducts.find(product => product.id === productId).images;
    const newIndex = currentIndex === 0 ? productImages.length - 1 : currentIndex - 1;
    return { ...prevState, [productId]: newIndex };
  });
};

const handleNextImageSimilarProduct = (productId) => {
  setSimilarProductImageIndexes((prevState) => {
    const currentIndex = prevState[productId] || 0;
    const productImages = similarProducts.find(product => product.id === productId).images;
    const newIndex = currentIndex === productImages.length - 1 ? 0 : currentIndex + 1;
    return { ...prevState, [productId]: newIndex };
  });
};


  const incrementQuantity = () => setQuantity(quantity + 1);
  const decrementQuantity = () => setQuantity(quantity > 1 ? quantity - 1 : 1);

const handleShare = () => {
  const shareData = {
    title: product.name,
    text: product.description,
    url: window.location.href,
  };

  if (navigator.share) {
    navigator.share(shareData).catch((error) => {
      console.error("Error sharing", error);
    });
  } else {
    const fallbackMessage = `${product.name}\n${product.description}\n${window.location.href}`;
    
    // Provide a mailto link (for email sharing)
    const mailtoLink = `mailto:?subject=${product.name}&body=${fallbackMessage}`;
    
    // Provide a fallback link for SMS sharing (on mobile)
    const smsLink = `sms:?body=${fallbackMessage}`;

    // Show an alert or offer these options to the user
    const userChoice = window.confirm(
      "Sharing is not supported. Would you like to email the product details instead?"
    );
    if (userChoice) {
      window.location.href = mailtoLink; // Open mail client for email sharing
    } else {
      window.location.href = smsLink; // Open SMS for mobile sharing
    }
  }
};

  if (!product) {
    return <p>Loading product details...</p>;
  }

  const formattedPrice = selectedMetalQuality === '18Kt' 
    ? `₹${parseFloat(product.price_18kt).toLocaleString()}`
    : selectedMetalQuality === '14Kt' 
    ? `₹${parseFloat(product.price_14kt).toLocaleString()}`
    : "Price not available";  // Show the price based on selected metal quality

  const filteredImages = productImages.filter(image => 
  selectedColor === 'all' || image.color === selectedColor
);

  const toggleDetails = (section) => {
    setDetailsVisible(prevState => ({
      ...prevState,
      [section]: !prevState[section]
    }));
  };

    const handleProductClick = (productId) => {
    navigate(`/product/${productId}`); // Navigate to ProductDetails page with the product ID
  };


    const handleMetalQualityChange = (metalQuality) => {
    setSelectedMetalQuality(metalQuality);
  };

const handleAddToCart = () => {
  const cartItem = {
    id: product.id,
    name: product.name,
    description: product.description,
    price_18kt: product.price_18kt,
    price_14kt: product.price_14kt,
    image_path: filteredImages[activeImageIndex]?.image_path,
    selectedColor: selectedColor,
    selectedMetalQuality: selectedMetalQuality,
    quantity: quantity,
  };

  // Retrieve existing cart items from localStorage
  const storedCart = JSON.parse(localStorage.getItem('cart')) || [];

  // Add the new cart item
  const updatedCart = [...storedCart, cartItem];

  // Store updated cart back to localStorage
  localStorage.setItem('cart', JSON.stringify(updatedCart));

  // Display an alert
  alert("Product added to cart");

  // Navigate to the cart page
  navigate('/cart');  // This will navigate to the '/cart' page
};



  return (
     <>
       <div className="product-details-page">
  <Header />
  {/* Other components */}
</div>


    <div className="product-details-container">
      <div className="product-left">
   <div className="image-carousel">
  {filteredImages.length > 0 ? (
    <img src={filteredImages[activeImageIndex]?.image_path} alt={product.name} />
  ) : (
    <p>No images available</p>
  )}
  <div className="image-slider-arrows">
    <FaChevronLeft className="arrow left" onClick={handlePrevImage} />
    <FaChevronRight className="arrow right" onClick={handleNextImage} />
  </div>
</div>

      </div>

      <div className="product-right">
        <h2>{product.name}</h2>
        <p className="product-description">{product.description}</p>
        <div className="product-price">{formattedPrice}</div>

       <div className="metal-options">
              <h5>Metal Quality</h5>
              <div className="metal-buttons mt-1">
                <button 
                  className={`metal-button ${selectedMetalQuality === '18Kt' ? 'active' : ''}`} 
                  onClick={() => handleMetalQualityChange('18Kt')}
                >
                  18Kt
                </button>
                <button 
                  className={`metal-button ${selectedMetalQuality === '14Kt' ? 'active' : ''}`} 
                  onClick={() => handleMetalQualityChange('14Kt')}
                >
                  14Kt
                </button>
              </div>
        </div>

        <div className="color-options1">

           <h6>Metal Colour: {selectedColor}</h6>
           <div className="color-options2">
 <div className="color-options">
  <div className="color-circle yellow" onClick={() => setSelectedColor('Yellow Gold')}></div>
  <div className="color-circle rose" onClick={() => setSelectedColor('Rose Gold')}></div>
  <div className="color-circle white" onClick={() => setSelectedColor('White Gold')}></div>

</div>

        <div className="quantity-control">
          <button onClick={decrementQuantity}>-</button>
          <span>{quantity}</span>
          <button onClick={incrementQuantity}>+</button>
        </div>
        </div>
  </div>
        

        <div className="product-details-footer">

          <div className="product-info1">
            <div>Gold Weight: {product.gold_weight}</div>
            <div>Diamond Weight: {product.diamond_weight}ct</div>
          </div>

          <div className="cta-buttons">
            <button className="cta-button try-at-home">Try at Home</button>
      <button className="cta-button add-to-cart" onClick={handleAddToCart}>
  Add to Cart
</button>

            <FaHeart className="wishlist-icon" />
            <FaShareAlt className="share-icon" onClick={handleShare} />
          </div>
        </div>
          <div className="details-section">
            {/* Customize Section */}
            <div className="details-header" onClick={() => toggleDetails('customize')}>
              <h4>Customize </h4>
              <span>{detailsVisible.customize ? <FaChevronUp /> : <FaChevronDown />}</span>
            </div>
            {detailsVisible.customize && (
              <div className="details-content">
                <p>Need a unique diamond or specific design adjustments? Fill out this form here or contact us at <a href="mailto:info@spinellejewelry.com">info@spinellejewelry.com</a>, and our expert artisans will bring your vision to life.</p>
                <p>If you wish to make any custom order, please WhatsApp us on <a href="https://wa.me/919966477192">+91 9966477192</a> and we will do our best to prioritize your order.</p>
              </div>
            )}

            {/* Shipping Section */}
            <div className="details-header" onClick={() => toggleDetails('shipping')}>
              <h4>Shipping & Handling </h4>
              <span>{detailsVisible.shipping ? <FaChevronUp /> : <FaChevronDown />}</span>
            </div>
            {detailsVisible.shipping && (
              <div className="details-content">
                <p>We offer Free Shipping on all domestic orders (within India). International orders are chargeable as per location.</p>
                <p>It takes 7-10 days to receive the product from the time of dispatch. This is not applicable for custom orders or orders where design is not provided by us.</p>
              </div>
            )}

            {/* Returns Section */}
            <div className="details-header" onClick={() => toggleDetails('returns')}>
              <h4>Returns & Refunds </h4>
              <span>{detailsVisible.returns ? <FaChevronUp /> : <FaChevronDown />}</span>
            </div>
            {detailsVisible.returns && (
              <div className="details-content">
                <p>We offer a hassle-free 15-day return policy, allowing you to return the item(s) you purchased within 15 days from the date of delivery.</p>
                <p>Once we receive the returned item(s) and inspect them to ensure they meet our return policy conditions, we will process your refund. Refunds will be issued to the original payment method used for the purchase. Please allow 10 business days for the refund to be processed and credited back to your account.</p>
              </div>
            )}
          </div>
      </div>

      {/* <div className="similar-products">
        <h3>Similar Products</h3>
        <div className="similar-products-grid">
          {/* Similar Products Render Logic 
        </div>
      </div> */}

      {/* <div className="sticky-bottom-bar">
        <button className="cta-button try-at-home">Try at Home</button>
        <button className="cta-button add-to-cart">Add to Cart</button>
      </div> */}
    </div>
<div className="similar-products">
  <h3 style={{marginBottom:10}}>Similar Products</h3>
<div className="similar-products-grid">
  {similarProducts.map(similarProduct => {
    const imageIndex = similarProductImageIndexes[similarProduct.id] || 0;
    const mainImage = similarProduct.images.length > 0 ? similarProduct.images[imageIndex].image_path : "";

    return (
      <div className="product-card" key={similarProduct.id}>
        <div className="product-image-container">
          <img src={mainImage} alt={similarProduct.name} />
          <FaHeart className="wishlist-icon" />
          <div className="image-slider-arrows">
            <FaChevronLeft onClick={() => handlePrevImageSimilarProduct(similarProduct.id)} />
            <FaChevronRight onClick={() => handleNextImageSimilarProduct(similarProduct.id)} />
          </div>
        </div>
        <div className="product-info" onClick={() => handleProductClick(similarProduct.id)}>
          <h4>{similarProduct.name}</h4>
          <p className="product-info-price">₹{parseFloat(similarProduct.price_18kt).toLocaleString()}</p>
        </div>
      </div>
    );
  })}
</div>

</div>

     <Footer/>
       
         <HelpTrigger/>
    </>
  );
};

export default ProductDetails;
